module.exports = __webpack_public_path__ + "img/photo10.bc5985ab.png";